<script>
import { CModal } from '@coreui/vue-pro';
import { registerDialog } from '@/utils/dialogAccessibility';

// Inherit the installed render/props/slots unchanged. Only dialog ownership and
// the installed Escape/listener/timer defects are adapted at application level.
export default {
  name: 'AccessibleModal',
  extends: CModal,
  watch: {
    show(value) {
      if (value) {
        this._closeRequested = false;
        this.$nextTick(this.activateDialog);
      } else this.releaseDialog();
    },
  },
  mounted() {
    window.removeEventListener('keydown', this.hideEsc);
    if (this.show) this.activateDialog();
  },
  updated() { if (this._dialog) this._dialog.refresh(); },
  activated() { if (this.show) this.activateDialog(); },
  deactivated() { this.releaseDialog(); },
  beforeDestroy() {
    this.releaseDialog();
    clearTimeout(this._visibleTimer);
    clearTimeout(this.timeout);
    window.removeEventListener('keydown', this.hideEsc);
  },
  methods: {
    activateDialog() {
      if (!this.show || this._isBeingDestroyed || this._isDestroyed || this._dialog) return;
      const element = this.$el.querySelector('[role="dialog"]');
      if (!element) return;
      this._dialog = registerDialog(element, {
        ready: () => this.visible,
        layers: () => [element, this.$el.querySelector('.modal-backdrop')],
        name: () => this.$attrs['aria-label'] || '',
        fallbackName: this.$t ? this.$t('common.dialog') : 'Dialog',
        close: event => {
          if (!this.onKey || this.onKey('', event.keyCode || 27) !== false) this.hide(event);
        },
      });
    },
    releaseDialog() {
      if (this._dialog) this._dialog.release();
      this._dialog = null;
    },
    hide(event, accept = false) {
      if (!this.show || this._closeRequested || (this._dialog && !this._dialog.isTop())) return;
      this._closeRequested = true;
      this.$emit('update:show', false, event, accept);
    },
    // The original mounted hook registers this; it is removed above. Keyboard
    // ownership belongs to the stack, rather than every open CoreUI modal.
    hideEsc() {},
    toggle(value) {
      clearTimeout(this._visibleTimer);
      this._visibleTimer = setTimeout(() => {
        if (!this._isBeingDestroyed && !this._isDestroyed) this.visible = value;
      }, 0);
      if (this.fade) {
        this.isTransitioning = true;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          if (!this._isBeingDestroyed && !this._isDestroyed) this.isTransitioning = false;
        }, 150);
      }
    },
  },
};
</script>
